<template>
  <div class="nft-card-comp" @click="flippCard">
    <slot name="status"></slot>
    <div class="nft-card-theme" :class="[className, activeEffect === 'ripple' ? 'nft-card-shake' : '']">
      <div class="nft-card-back card-front" v-if="!loading">
        <div class="card-line">
          <nft-line-svg :type="data.cltnType" :color="nftData.color" />
        </div>
        <div class="tag-area">
          <p class="tag-name" v-if="disabledStatus">
            {{ $t(`nftCard.${disabledStatus}`) }}
          </p>
          <p class="tag-name" v-else>{{ $t(nftData.tag) }}</p>
        </div>
        <div class="logo-area">
          <div v-if="nftData.grouping && !onList" class="float-right-info">
            {{ $t('nftCard.entry') }}: {{ data.groupCount }}
          </div>
        </div>
        <div class="nft-image mb-16">
          <img :src="nftData.image" class="nft-image-el" />
          <div v-if="nftData.status === 'SENDING'" class="nft-status-image">
            {{ $t('nftCard.sendingLogo') }}
          </div>
          <div v-else-if="nftData.status === 'SELLING'" class="nft-status-image nft-status-image-primary">
            <div>
              {{ $t('nftCard.selling') }}
            </div>
            <div class="more-btn">
              {{ $t('common.more') }}
            </div>
          </div>
          <div v-else-if="nftData.status === 'SELL_REG'" class="nft-status-image nft-status-image-gray">
            {{ $t('nftCard.regitSelling') }}
          </div>
          <div v-else-if="nftData.status === 'SELL_REG_FAIL'" class="nft-status-image nft-status-image-red">
            {{ $t('nftCard.regitSellingFail') }}
            <div class="more-btn">
              {{ $t('nftCard.solving') }}
            </div>
          </div>
          <div v-else-if="nftData.status === 'SEND_FAIL'" class="nft-status-image nft-status-image-fail">
            {{ $t('nftCard.sendingFailed') }}
          </div>
          <div v-else-if="nftData.status === 'FAIL'" class="nft-status-image nft-status-image-fail">
            {{ $t('nftCard.failed') }}
          </div>
          <div v-else-if="nftData.isWait" class="nft-status-image nft-status-image-qtnr">
            <img src="@/assets/images/icons/mystery.svg" class="mystery-img">
            <div class="desc-text">
              {{ $t('nftCard.status.wait.required') }}
            </div>
          </div>
          <div v-else-if="!nftData.isQtnr && !disabledStatus" class="nft-status-image nft-status-image-qtnr">
            <img src="@/assets/images/icons/info_white.svg">
            <div class="desc-text">
              {{ $t('nftCard.status.qtnr.required') }}
            </div>
            <MvButton
                :text="$t('nftCard.status.qtnr.submit')"
                type="rec-primary"
                @click.stop="$router.push({ name: 'NftQtnrView', params: {id: nftData.id} })"
            />
          </div>
          <div class="center-icon" v-if="centerIcon">
            <img :src="centerIcon.src" :class="centerIcon.className" />
          </div>
        </div>
        <div class="name-area">
          <p class="offer-name">{{ nftData.cltnName }}</p>
          <p v-if="nftData.name" class="nft-name">
            {{ nftData.name }}
          </p>
          <div class="fixed-info">
            <p v-if="data?.seat?.id">
              {{ $t('nftCard.seat') }}: {{ data?.seat?.name }}
            </p>
          </div>
        </div>
        <div class="divider"></div>
        <div class="card-footer">
          <div class="footer-qr-container">
            <img src="@/assets/images/icons/mini_qr.svg" />
          </div>
        </div>
      </div>
      <div class="nft-card-back card-back" v-if="!flipLock">
        <div class="card-line">
          <nft-line-svg :type="data.cltnType" :color="nftData.color" />
        </div>
        <div class="logo-area">
          <div v-if="data?.seat?.id" class="float-seat-btn cursor-pointer" @click.stop="$router.push({ name: 'NftSeatMapView', params: { id: data.id }, query: { link: accessLink } })">
            <img src="@/assets/images/icons/map-pin.svg" alt="">
            <div>
              {{ $t('nftCard.seatMap') }}
            </div>
          </div>
          <div v-if="info" class="float-info-img cursor-pointer" @click.stop="toggleModal(true)">
            <img src="@/assets/images/icons/nft-info.svg" alt="">
          </div>
        </div>
        <div class="qr-row">
          <div class="qr-image-area mb-8" v-if="!qrStatus && !data.isQpass">
            <img :src="qrImage" alt="qr-code" />
          </div>
          <div class="qr-status-area mb-8" v-else>
            <qr-status-comp
                :attributes="data.attributes"
                :nft-id="data.id"
                :seat-start-date="data.seatStartDate"
                :need-seat="nftData.isSeat && !data?.seat?.id"
                :cltn-id="data.cltnId"
                :is-qpass="data.isQpass"
                :type="data.cltnType"
                :status="qrStatus"
                :open-date="data.openDate ? data.openDate : data?.attributes?.openDate"
                :time-zone="data?.attributes?.timeZone"
            />
          </div>
        </div>
        <pay-card-back v-if="data.type === 'PAY'" :qr-image="qrImage" :data="data"/>
        <mmbs-card-back v-else-if="data.cltnType === 'MEMBERSHIP' && !isPreview" :qr-image="qrImage" :data="data" />
        <ticket-card-back v-else-if="data.cltnType === 'TICKET'" :qr-image="qrImage" :data="data" />
      </div>
    </div>
    <div v-if="activeEffect === 'ripple'" class="effect-overlay effect-ripple">
      <div class="ripple-circle r1"></div>
      <div class="ripple-circle r2"></div>
      <div class="ripple-circle r3"></div>
      <img src="@/assets/images/icons/check.svg" class="ripple-check-icon" />
    </div>
  </div>
  <bottom-slide-sheet v-model:visible="isOpen" @click.stop v-if="isOpen" :max-height="true">
    <template #content>
      <nft-card-info-comp :data="data" @cancel="toggleModal(false)" :is-header="false"></nft-card-info-comp>
    </template>
  </bottom-slide-sheet>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted, reactive,
  ref,
  watch,
} from "vue";
import { getNftTCtgy } from "@/script/constantScript";
import { NftCtgy } from "@/models/types";
import MmbsCardBack from "@/components/common/card/card_back/MmbsCardBack.vue";
import TicketCardBack from "@/components/common/card/card_back/TicketCardBack.vue";
import PayCardBack from '@/components/common/card/card_back/PayCardBack.vue';
import QrStatusComp from "@/components/common/card/card_back/QrStatusComp.vue";
import NftLineSvg from "@/components/svg/NftLineSvg.vue";
import MvButton from '@/components/common/button/MvButton.vue';
import { dataToUrl } from "@/script/common/qrScript";
import dayjs from "@/utils/dayjs";
import { useGenerateQRData } from "@/script/nft/nftDetailScript";
import { useRoute } from "vue-router";
import BottomSlideSheet from "@/components/common/modal/BottomSlideSheet.vue";
import { useModal } from "@/script/common/modalScript";
import NftCardInfoComp from "../modal/comp/NftCardInfoComp.vue";
import {isQtnrCplt} from '@/script/nft/nftQtnrScript';
import {useI18n} from 'vue-i18n';
import {formatDate} from '@/models/utils/dateUtils';
import {getNftStatusApi} from '@/api/nftApis';
import {getNftStatusByLinkApi} from '@/api/accessLinkApis';

export default defineComponent({
  name: "NftCardComp",
  components: {
    MmbsCardBack,
    TicketCardBack,
    NftLineSvg,
    QrStatusComp,
    BottomSlideSheet,
    NftCardInfoComp,
    PayCardBack,
    MvButton,
  },
  props: {
    flipLock: {
      default: false,
    },
    disabled: {
      default: "",
    },
    flipAppear: {
      default: false,
    },
    loading: {
      default: false,
    },
    onList: {
      default: false,
    },
    data: {
      default: {
        id: "",
        cltnType: "",
        tokenId: "",
        color: "",
        logoImg: "",
        image: "",
        cltnName: "",
        cltnId: "",
        name: "",
        isExpired: false,
        isLock: false,
        status: "",
        qrData: "",
        type: "",
        openDate: "",
        useCnt: "",
        memo: "",
        grouping: null,
        seatStartDate: null,
        attributes: {
          startDate: "",
          openDate: "",
          timeZone: "",
          isWait: "",
          isSeat: false,
          hideOptions: {
            startDate: false,
          },
          notFlip: false,
        },
        nftUseStatus: {
          totalCnt: 0,
          useableCnt: 0,
        },
        qtnrTemplate: [],
        qtnrInfo: {},
      },
    },
    isPreview: {
      default: false
    },
    sleep: {
      default: false
    },
    qrData: {
      default: "",
    },
    info: {
      default: false,
    },
    accessLink: {
      default: ''
    },
  },
  setup(props, context) {
    const { qrData, loading: qrLoading, generateQRData, accessLink } = useGenerateQRData();
    const route = useRoute();
    const { t } = useI18n()
    const nftId = route.params.id;
    const updated = reactive({
      status: ''
    })
    const qrImage = ref("");
    const nftData = computed(() => {
      const data = props.data;
      const nftCtgy = getNftTCtgy(data.cltnType as NftCtgy);
      const getName = () => {
        const displayDate = !data.attributes?.hideOptions?.startDate
        let nftName = data.name
        if (nftName.indexOf('#') === -1 && data.cltnType === 'TICKET' && displayDate) {
          const dateString = data.attributes?.startDate
              ? formatDate(data.attributes.startDate, { format: t('nftCard.nameDateForm'), timeZone: data.attributes.timeZone })
              : ''
          nftName += `_${dateString}` + (data.tokenId ? ` #${data.tokenId}` : '')
        }
        return nftName
      }
      return {
        id: data.id,
        tag: nftCtgy.tag,
        color: data.color?.toLowerCase(),
        logoImg: data.logoImg,
        image: data.image,
        cltnName: data.cltnName,
        cltnId: data.cltnId,
        name: getName(),
        isExpired: data.isExpired,
        status: props.isPreview ? "ACTIVE" : data.status,
        isQtnr: data.qtnrTemplate ? isQtnrCplt(data.qtnrInfo, data.qtnrTemplate) : true,
        isWait: data.attributes.isWait,
        isSeat: data.attributes.isSeat,
        grouping: data.grouping
      };
    });

    const disabledStatus = computed(() => {
      const status = updated.status ? updated.status : props.data.status
      if (props.data) {
        if (props.disabled === "lock" || props.data.isLock) return "lock";
        if (props.disabled === "expired" || props.data.isExpired)
          return "expired";
        if (status === "USED") return "used";
      }
      return false;
    });

    const className = computed(() => {
      const name: string[] = [];
      if (props.loading) return name.push("card-loading");
      if (props.data.isExpired) name.push("nft-expired");
      if (props.data.color) {
        if (props.data.type === 'PAY') name.push('nft-color-pay')
        else name.push(`nft-color-${nftData.value.color}`)
      }
      if (isFlip.value) name.push("nft-card-flipped")
      if (props.data.cltnType === "TICKET") name.push("nft-card-comp-ticket")
      if (props.data.cltnType === "MEMBERSHIP") name.push("nft-card-comp-mmbs")
      if (props.data.type === 'PAY') name.push('nft-card-comp-pay')
      if (disabledStatus.value) {
        name.push("nft-card-disabled")
      }
      return name.join(' ');
    });

    const qrStatus = computed(() => {
      const data = props.data;
      if (disabledStatus.value) return disabledStatus.value;
      if (data.openDate) {
        if (dayjs().isBefore(data.openDate)) {
          return 'beforeOpen'
        }
      } else if (data.attributes?.openDate) {
        if (dayjs().isBefore(data.attributes?.openDate)) {
          return 'beforeOpen'
        }
      } else if (data.cltnType === "TICKET") {
        if (data.attributes.startDate) {
          if (dayjs().isBefore(dayjs(data.attributes.startDate)))
            return "ticketLock";
        }
      }
      return false;
    });

    const centerIcon = computed(() => {
      if (disabledStatus.value === "used") {
        return {
          src: require("@/assets/images/icons/used_mark.png"),
          className: "used-mark",
        };
      }
      if (disabledStatus.value === "lock") {
        return {
          src: require("@/assets/images/icons/lock_gray.png"),
          className: "lock-mark",
        };
      }
      return false;
    });

    const activeEffect = ref<string | null>(null);
    const triggerEffect = () => {
      activeEffect.value = 'ripple';
      setTimeout(() => { activeEffect.value = null; }, 1600);
    };

    let refreshQRData1: any;
    let refreshNftStatus: any;
    const isFlip = ref(false);
    const flippCard = async () => {
      if (!props.flipLock) isFlip.value = !isFlip.value;
      if (!isFlip.value) {
        clearInterval(refreshQRData1);
        clearInterval(refreshNftStatus);
      }
      if (isFlip.value && qrData.value.qrType === "DYNAMIC" && !qrStatus.value) {
        await generateQRData(props?.data.id);
        refreshQRData1 = setInterval(async () => {
          if (!props.sleep) await generateQRData(props?.data.id);
        }, (qrData.value.qrValidTime - 1) * 1000);
      }
      if (isFlip.value && props?.data.id) {
        let useCnt = props.data.useCnt
        refreshNftStatus = setInterval(async () => {
          let newCnt = useCnt
          if (!props.sleep && !qrStatus.value) {
            let status
            if (props.accessLink) {
              const nftResult = await getNftStatusByLinkApi(props.data.id, props.accessLink)
              newCnt = nftResult.useCnt
              status = nftResult.status
            } else {
              const nftResult = await getNftStatusApi(props.data.id)
              newCnt = nftResult.useCnt
              status = nftResult.status
            }
            updated.status = status
            if (status === 'USED') {
              clearInterval(refreshQRData1);
              clearInterval(refreshNftStatus)
            } else if (newCnt !== useCnt) {
              useCnt = newCnt
              triggerEffect()
              if (props.data.memo) {
                setTimeout(() => { toggleModal(true) }, 1000);
              }
            }
          }
        }, 1000);
      }
    };
    const ticketLock = computed(() => {
      if (props.data.cltnType === "TICKET") {
        return dayjs().isBefore(dayjs(props.data.attributes.startDate));
      }
      return false;
    });
    watch(
        () => props.sleep,
        async (next, prev) => {
          if (!next && prev) {
            await generateQRData(props?.data.id);
          }
        }
    );
    watch(
      () => qrData.value,
      async (next) => {
        if (next) qrImage.value = await dataToUrl(qrData.value.qrData);
      }
    );
    watch(() => props.data, async (next, prev) => {
      if (next && !prev && isFlip) {
        await generateQRData(props.data.id);
      }
    })
    onMounted(async () => {
      accessLink.value = props.accessLink
      await generateQRData(props.data.id);
      if (props.flipAppear && !props.data.attributes.notFlip) {
        isFlip.value = false;
        setTimeout(() => {
          flippCard()
        }, 500);
      }
    });
    onUnmounted(() => {
      clearInterval(refreshQRData1)
      clearInterval(refreshNftStatus)
    });
    const { isOpen, toggleModal } = useModal()
    return {
      nftData,
      className,
      flippCard,
      centerIcon,
      disabledStatus,
      qrImage,
      ticketLock,
      qrStatus,
      isOpen,
      toggleModal,
      activeEffect,
      triggerEffect
    };
  },
});
</script>
